import { Enums } from "../common/enums";

export class OpActionResult {
    
    //Properties

    public idAction: number
    public referenceValue: number
    public exceptionMessage: string
    public runActionResult: Enums.RunActionResult

    //Properties end

    constructor(opObj: any) {
        if (opObj) {
            this.idAction = opObj.IdAction
            this.referenceValue = opObj.ReferenceValue
            this.exceptionMessage = opObj.ExceptionMessage
            this.runActionResult = opObj.RunActionResult
        } else {
            this.idAction = 0;
        }
    }
}